import { NumberDecimalFormat } from '@components/shared/Format'
import { Constants } from '@models/Constants'
import { Store } from '@stores/Store'

export class PerformancePlusCalculation {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Performance Plus

  get performancePlusMonthlyPpvValue() {
    const { store } = this
    const { countryData } = store

    return countryData.newPerformancePlusMonthlyPv
  }

  get performancePlusPerformanceBonusMonthlyMultipier(): number {
    const { store } = this
    const { performancePlusStore } = store
    const { performancePlusTracking } = performancePlusStore

    if (!performancePlusTracking) { return 0 }

    return Constants.PERFORMANCE_PLUS_PERFORMANCE_BONUS_MONTHLY_MULTIPLIER
  }

  get performancePlusMonthlyAmount(): number {
    const { store } = this
    const { performanceBonus } = store

    if (this.performancePlusllCriteriaMet) {
      return NumberDecimalFormat(performanceBonus * this.performancePlusPerformanceBonusMonthlyMultipier)
    }

    return 0
  }

  get performancePlusAnnualAmount(): number {
    return this.performancePlusMonthlyAmount * 12
  }

  get performancePlusllCriteriaMet(): boolean {
    const { store } = this
    const { performancePlusStore } = store
    const { performancePlusActive } = performancePlusStore

    if (!performancePlusActive) { return false }

    return this.prqMonthCriteriaMet && this.monthlyPpvCriteriaMet
  }

  get monthlyPpvCriteriaMet(): boolean {
    const { store } = this
    const { personalPV } = store

    return personalPV >= this.performancePlusMonthlyPpvValue
  }

  get prqMonthCriteriaMet(): boolean {
    return this.groupPvCriteriaMet || this.groupPvLegCriteriaMet
  }

  get groupPvCriteriaMet(): boolean {
    const { store } = this
    const { groupPV, countryData } = store

    return groupPV >= countryData.performanceBonus.percent21
  }

  get groupPvLegCriteriaMet(): boolean {
    const { store } = this
    const { groupPV, countryData } = store

    return (groupPV >= countryData.performanceBonus.percent15) && this.depthBonusFrontlineLegsCriteriaMet
  }

  get depthBonusFrontlineLegsCriteriaMet(): boolean {
    const { store } = this
    const { computedFrontlines } = store

    const result = computedFrontlines.filter((frontline) => frontline.depthBonusLevelCriteriaMet)
    return result && result.length >= Constants.PERFORMANCE_PLUS_DEEP_BONUS_CRITERIA_MIN_FRONTLINE_LEGS
  }

}
